import {useCallback, useState} from "react";


export default function useTriStateSort(onChange) {
    const [sortFields, setSortFields] = useState([]);

    const handleSort = useCallback(
        (field) => {
            setSortFields((prev) => {
                const existing = prev.find((s) => s.field === field);
                let updated;

                if (!existing) {

                    updated = [...prev, {field, direction: "ASC"}];
                } else if (existing.direction === "ASC") {

                    updated = prev.map((s) =>
                        s.field === field ? {...s, direction: "DESC"} : s
                    );
                } else if (existing.direction === "DESC") {

                    updated = prev.filter((s) => s.field !== field);
                }

                onChange?.(updated);
                return updated;
            });
        },
        [onChange]
    );

    const getSortProps = useCallback(
        (field) => {
            const existing = sortFields.find((s) => s.field === field);
            return {
                active: !!existing,
                direction: existing?.direction?.toLowerCase() || "asc",
            };
        },
        [sortFields]
    );

    const clearSort = useCallback(() => {
        setSortFields([]);
        onChange?.([]);
    }, [onChange]);

    return {sortFields, handleSort, getSortProps, clearSort};
}
